//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    showcase: Object,
    smallTicketItems: {
      type: Boolean,
      default: false
    }
  }
}
